// The AIChatPanel component passes this storage key to a ChatCompose component, which will
// use it to persist the state of the chat conversation in local storage.
export const AI_PROMPT_STORAGE_KEY = "ai_prompt";

// TODO: I haven't pinned down exactly what this is for, or what makes it special relative
// to other values that can be passed to `useAIContext`. Still digging. (JN)
export const AI_WORKSHEET_CONTEXT_KEY = "worksheet";

export const AI_TOOL_CALL_HINT_CONTEXT_KEY = "tool_call_hint";
